import queryString from 'query-string';
import get from 'lodash/get';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import getPageNumberString from 'rebook/apps/utils/text/getPageNumberString';
import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import {
  CATALOG_TAG_LIST_SET_DATA,
  CATALOG_TAG_DETAIL_RESET_DATA,
} from 'rebook/apps/catalog/constants';


export const fetchInitialData = (match, location = {}) => {
  return async(dispatch, getState) => {
    const { ssr, authorList: currentState } = getState();
    const { o: locationSearch } = queryString.parse(get(location, 'search'));
    const orderBy = locationSearch ? locationSearch : get(ssr, 'query.o', 'asc');
    const pageNumber = ssr.query && ssr.query.page
      ? parseInt(ssr.query.page, 10)
      : 1;

    let newState = {
      pageNumber,
      orderBy,
    };

    if (location && location.state) {
      newState = {
        ...newState,
        ...location.state,
      };
    }

    if (currentState) {
      newState = {
        ...newState,
        ...currentState,
      };
    }

    dispatch(setSeoMeta(pageNumber));

    if (!get(newState, 'list', null)) {
      await dispatch(fetchTagsList({ pageNumber, orderBy }));
    }
  };
};

export const fetchTagsList = (params = {}) => {
  return async(dispatch, getState) => {
    const { ssr, tagList } = getState();
    const mergedState = { ...tagList, ...params };
    const { paginateBy, orderBy, pageNumber } = mergedState;
    let queryParams = {
      offset: (pageNumber - 1) * paginateBy,
      limit: paginateBy,
      o: orderBy,
    };

    dispatch(setData({
      list: null,
    }));

    const qs = queryString.stringify(queryParams);
    const url = `/api/tags/?${qs}`;

    return await (
      fetchQuery(url, { headers: ssr.headers })
        .then(({ data }) => {
          const lastPageNumber = Math.ceil(data.meta.total_count / paginateBy);
          dispatch(setData({
            list: data.objects,
            totalAuthorsCount: data.meta.total_count,
            pageNumber,
            orderBy,
            lastPageNumber,
          }));
        })
        .catch(({ data, resp, error }) => {
          Raven.captureMessage('failed to load author list data due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
              error,
            },
          });
        })
    );
  };
};

export const setSeoMeta = (pageNumber) => {
  return (dispatch) => {
    const canonicalUrl = `https://${BASE_HOST}/tags/`;
    const title = `Самые популярные темы книг — MyBook. ${getPageNumberString(pageNumber)}`.trim();
    const description = `Каталог лучших книг и новинок литературы. ` +
                        `Рейтинги книг и рецензии читателей. ` +
                        `Искусство, детективы, любовные романы, детские книги, психология, ` +
                        `фэнтези, фантастика, дом, семья, приключения. ` +
                        `Возможность удобно читать книги онлайн по подписке.`;
    dispatch(SeoActions.setData({
      canonicalUrl,
      title,
      description,
      pageNumber,
    }));
  };
};

export const setData = (payload) => {
  return (dispatch) => {
    dispatch({
      type: CATALOG_TAG_LIST_SET_DATA,
      payload,
    });
  };
};

export const resetData = () => {
  return (dispatch) => {
    dispatch(SeoActions.resetData());
    dispatch({
      type: CATALOG_TAG_DETAIL_RESET_DATA,
    });
  };
};
